let planiDesignerState = {
    version: "0.0.1",
    drawing: null,
    cursorPosition: {
        x: 0,
        y: 0
    },
    zoomLevel: 1,
    currentAction: "Pointer",
    selectedElement: null,
    currentColor: "#000000",
    wallOrigin: 'Top',
    wallThickness: 5,
    cursorSnap: 'None',
};
export default planiDesignerState;
